import request from '@/utils/request'


// 查询广告信息列表
export function listBanner(query) {
  return request({
    url: '/index/banner/list',
    method: 'get',
    params: query
  })
}

// 查询广告信息分页
export function pageBanner(query) {
  return request({
    url: '/index/banner/page',
    method: 'get',
    params: query
  })
}

// 查询广告信息详细
export function getBanner(data) {
  return request({
    url: '/index/banner/detail',
    method: 'get',
    params: data
  })
}

// 新增广告信息
export function addBanner(data) {
  return request({
    url: '/index/banner/add',
    method: 'post',
    data: data
  })
}

// 修改广告信息
export function updateBanner(data) {
  return request({
    url: '/index/banner/edit',
    method: 'post',
    data: data
  })
}

// 删除广告信息
export function delBanner(data) {
  return request({
    url: '/index/banner/delete',
    method: 'post',
    data: data
  })
}
